// extracted by mini-css-extract-plugin
export default {"container":"layout_container__+uCSl","main":"layout_main__YYtd2","scroller":"layout_scroller__a83My","page":"layout_page__0HXFG"};